Application.Popups = {
    ui: {
        opener: '.open-popup',
        container: '.popup',
        fade: '.popup__fade',
        close: '.popup__close'
    },
    ready: function () {

        var self = this;

        $(document).on('click', this.ui.opener, function(event){
            event.preventDefault();
            self.open($(this).data('popup-id'));
        });

        $(document).on('click', this.ui.close, function(event){
            event.preventDefault();
            self.close($(this).closest(self.ui.container));
        });
        $(document).on('click', this.ui.fade, function(event){
            event.preventDefault();
            self.close($(this).closest(self.ui.container));
        });

    },
    open: function(id){

        var $el = $(this.ui.container).filter('#' + id);
        $el.addClass('popup_active');
        $('body').addClass('popup-active');

    },
    close: function($el){

        $el.removeClass('popup_active');
        $el.removeClass('popup_mobile');
        $('body').removeClass('popup-active');

        if($el[0].id=='popup-christmas'){
            var $floater = $('.floater');
            if($floater.length){
                $floater.addClass('floater--active');
            }
        }

    }
};